// @flow
import { ConfigurationsActionTypes } from './constants';

const INIT_STATE = {
    configuration: {},
    loading: false,
    error: false,
    formSubmited: false,
};

type ConfigurationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { configuration?: {} | null, listaConfigurations?: [] | null, loading?: boolean, +value ?: boolean };

const Configuration = (state: State = INIT_STATE, action: ConfigurationsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ConfigurationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ConfigurationsActionTypes.GET_CONFIGURATION: {
                    return {
                        ...state,
                        configuration: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ConfigurationsActionTypes.UPDATE_CONFIGURATION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }


        case ConfigurationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ConfigurationsActionTypes.GET_CONFIGURATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        configuration: {},
                        loading: false,
                    };
                }
                case ConfigurationsActionTypes.UPDATE_CONFIGURATION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ConfigurationsActionTypes.GET_CONFIGURATION:
            return { ...state, error: false, loading: true };
        case ConfigurationsActionTypes.UPDATE_CONFIGURATION:
            return { ...state, error: false, loading: true };
        case ConfigurationsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                configuration: {},
                formSubmited: false
            };
        case ConfigurationsActionTypes.RESET_BASIC:
            return {
                ...state,
                loading: false,
                error: false,
                formSubmited: false,
            };
        default:
            return { ...state };
    }
};

export default Configuration;
